/**
 * Created by Sergii on 4/27/2017.
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import ClickAwayListener from 'react-click-away-listener';
import { OTHER_LAB_OPTION_NAME, OTHER_TEST_OPTION_NAME, TestStatuses } from '../const/TestResultsConst';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import GenesTableController from "../containers/GenesTableController.jsx";
import {I18n} from 'react-redux-i18n';
import isEmpty  from 'lodash/isEmpty';
import isNumber  from 'lodash/isNumber';
import { Button } from '@common/components/Button';
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@common/components/modal';
import { ErrorText } from '@common/components/error-text';
import Dropdown, { components } from '@common/containers/fields/Dropdown';
import { Flex } from '@common/components/Flex';
import { getTestAttributes } from '@common/utils/tests';
import { FormControl } from '@common/components/form-control';

import '../styles/TestDetailsWnd.scss';

var localDateFormat; // define a proper date format due to browser locale

function getLocalFormat() {
    var testDate = new Date(Date.UTC(2017, 11, 31));
    var localDate = testDate.toLocaleDateString(window.navigator.userLanguage || window.navigator.language);
    return localDate.replace("2017", "yyyy").replace("12", "mm").replace("30", "dd").replace("31", "dd");
}

export class TestDetailsWnd extends Component {
    constructor (props) {
        super(props);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleDateBlur = this.handleDateBlur.bind(this);
        this.hasErrors = this.hasErrors.bind(this);
        this.onOutsideClick = this.onOutsideClick.bind(this);

        var locale = window.navigator.userLanguage || window.navigator.language;
        localDateFormat = getLocalFormat();
        moment.locale(locale);

        this.topLabel = I18n.t('topLabel');

        if (props.loadBlacklistFileExtensions) {
            props.loadBlacklistFileExtensions();
        }
    };
    
    state = {
        errorMessages: {
            otherTest: undefined,
            otherLab: undefined,
        },
        uploadedDocumentsMenuOpened: false,
    };

    static defaultProps = {
        blacklistFileExtensions: [],
        testsOrdered: [],
        documents: [],
        fileNames: [],
        errors: {},
    };

    handleOnChange (target) {
        this.props.saveFieldValue(target.field || target.id, target.value);
    };

    handleDateChange(id, value) {
        if (!value) {
            this.props.onValidationResult(id, true);
            return;
        }
        const m = moment(value);
        if (m.isValid()) {
            const result = m.utc();
            this.props.saveFieldValue(id, result);
            this.props.onValidationResult(id, false);
        } else {
            this.props.onValidationResult(id, true);
        }
    };

    handleDateBlur (target) {
        if (target.value === "") {
            this.props.onValidationResult(target.id, false);
            var oldVal = this.props.test[target.id];
            if (oldVal !== target.value) {
                this.props.saveFieldValue(target.id, target.value);
            }
        } else {
            var date = moment(target.value, "L", true);
            if (date.isValid()) {
                this.props.onValidationResult(target.id, false);
                var oldVal = this.props.test[target.id];
                if (!date.isSame(oldVal)) {
                    var result = moment(date).utc().add(date.utcOffset(), 'm');
                    this.props.saveFieldValue(target.id, result);
                }
            } else {
                this.props.onValidationResult(target.id, true);
            }
        }
    };

    hasErrors() {
        if (Object.values(this.state.errorMessages).filter((x) => Boolean(x)).length) {
            return true;
        }

        for (var error in this.props.errors) {
            if (this.props.errors[error] == true) {
                return true;
            }
        }
    };

    get hasSomeDataEntered() {
        const { test, fileNames = [] } = this.props;
        const fields = Object.keys(test);
        const fieldsToOmit = ['ambryId', 'globalId', 'id', 'potentialFamilyMemberReports','orderid'];

        const hasDataEntered = fields.some((fieldName) => {
            if (fieldsToOmit.includes(fieldName)){
                return false;
            }

            const value = test[fieldName];

            const hasData = (v) => isNumber(v) ? true : !isEmpty(v);

            if (Array.isArray(value)) {
                const specialChecks = {
                    genes: {
                        requiredFields: ['classification', 'gene', 'priorClassification', 'variant']
                    }
                };
                const currentFieldSpecialChecks = specialChecks[fieldName];

                if (currentFieldSpecialChecks) {
                    const { requiredFields } = currentFieldSpecialChecks;

                    return value.some((item) => {
                        return requiredFields.some((requiredField) => {
                            const requiredFieldValue = item[requiredField];

                            return hasData(requiredFieldValue);
                        });
                    });
                }

                const hasItems = Boolean(value.length);

                return hasItems;
            }

            return hasData(value);
        });

        return hasDataEntered || Boolean(fileNames.length);
    }

    onOutsideClick() {
        this.picker1.cancelFocusInput();
        this.picker2.cancelFocusInput();
        this.picker3.cancelFocusInput();
    }

    onUpload = (e) => {
        e.persist()

        const getExtension = (fileName) => (fileName.split('.').pop()).toLowerCase();

        const { blacklistFileExtensions } = this.props;
        const files = Array.from(e.target.files);
        const validFiles = files.filter(({ name }) => !blacklistFileExtensions.includes(getExtension(name)));

        const { showBlacklistUploadedFilesMessage, onDocsUploaded } = this.props;

        if (files.length !== validFiles.length) {
            showBlacklistUploadedFilesMessage();
        }

        if (validFiles.length) {
            onDocsUploaded(validFiles);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.test.potentialFamilyMemberReports === true && this.props.multipleReportsShown === false) {
            this.props.showMultipleReportsMessage(this.props.test.id);
        }

        if (this.props.show !== prevProps.show) {
            this.setState(({ errorMessages, ...otherState }) => ({
                ...otherState,
                errorMessages: {
                    otherTest: undefined,
                    otherLab: undefined,
                }
            }));
        }
    }

    setErrorMessage = (error) => {
        this.setState(({ errorMessages, ...otherState }) => ({
            ...otherState,
            errorMessages: {
                ...errorMessages,
                ...error,
            },
        }));
    }

    handleOtherTestChange = (e) => {
        if (e.target.value.length > 100 && !this.state.errorMessages.otherTest) {
            this.setErrorMessage({
                otherTest: I18n.t('Must not exceed 100 characters'),
            });
        } 
        
        if (e.target.value.length <= 100 && this.state.errorMessages.otherTest) {
            this.setErrorMessage({
                otherTest: undefined,
            });
        }

        this.handleOnChange({ field: 'otherTestOrdered', value: e.target.value });
    }

    handleOtherLabChange = (e) => {
        if (e.target.value.length > 50 && !this.state.errorMessages.otherLab) {
            this.setErrorMessage({
                otherLab: I18n.t('Must not exceed 50 characters'),
            });
        } 
        
        if (e.target.value.length <= 50 && this.state.errorMessages.otherLab) {
            this.setErrorMessage({
                otherLab: undefined
            });
        }

        this.handleOnChange({ field: 'otherLab', value: e.target.value });
    }

    handleUploadedDocumentsMenuOpen = () => {
        this.setState((x) => ({
            ...x,
            uploadedDocumentsMenuOpened: true,
        }));
    }

    handleUploadedDocumentsMenuClose = () => {
        if(!this.state.uploadedDocumentsMenuOpened) {
            return;
        }

        this.setState((x) => ({
            ...x,
            uploadedDocumentsMenuOpened: false,
        }));
    }

    getMenuListComponent = (content) => (props) => {
        return (
            <components.MenuList {...props}>
                {content}
            </components.MenuList>
        );
    };
    
    getControlComponent = (content) => ({ cx, children, ...rest }) => (
        <components.Control cx={() => {}} {...rest}>
            <Button
                onClick={this.handleUploadedDocumentsMenuOpen}
                style={{ width: "100%", borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                >
                {content}
            </Button>
        </components.Control>
    );

    render () {
        for (var i=0; i<this.props.test.genes.length; i++) { // set up properly unique ids
            if (this.props.test.genes[i].id === '') this.props.test.genes[i].id = i;
            this.props.test.genes[i].rowNumber = i;
        }

        var positiveGenes = this.props.test.genes.filter(gene => gene.classification && gene.classification.length > 0 && gene.classification.toUpperCase() !== I18n.t('negative').toUpperCase());
        var results = positiveGenes.map(gene => { return gene.classification + ' ' + gene.gene }).join(', ');

        var labs = this.props.labs.map((lab) => {
            return lab;
        });
        
        var currentTestLab = this.props.test.lab;
        if (currentTestLab && !this.props.labs.includes(currentTestLab)) {
            labs.push(currentTestLab);
        }

        const uniqueLabs = [...new Set(labs)];

        if (this.props.testsOrdered.indexOf(this.props.test.testOrdered) === -1) {
            this.props.testsOrdered.push(this.props.test.testOrdered);
        }
        const testsEnabled = this.props.testsOrdered && this.props.testsOrdered.length > 0;
        var testsOrdered = this.props.testsOrdered.filter(Boolean).map((test,index) => {
            return test;
        });

        var statuses = Object.keys(TestStatuses).map((key,index) => {
            return I18n.t(TestStatuses[key])
        });

        var docWord = this.props.documents.length + this.props.fileNames.length === 1 ? I18n.t('document') : I18n.t('documents');
        var docsButton = <div style={{display: 'inline'}}>
            <span style={{
                float: 'left',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                display: 'block',
                width: 'calc(100% - 20px)',
                textAlign: 'left',
                fontSize: '13px'
            }}>{(this.props.documents.length + this.props.fileNames.length - (this.props.toDelete ? this.props.toDelete.length : 0)) + " " + docWord}</span>
            <span className="glyphicon glyphicon-triangle-bottom pull-right" style={{fontSize: '0.65em', paddingTop: '6px'}}></span>
        </div>;

        var docsList = this.props.documents.map((doc, index) => {
            if (this.props.toDelete && this.props.toDelete.filter(id => doc.id == id).length > 0) return;
            return <Flex alignItems="center" key={index}
                            style={{cursor: 'default', padding: "4px"}}
                            className="docs-dropdown-test-detail-menu-item"
            >
                <span data-toggle="tooltip"
                    title={doc.fileName}
                    style={{
                        cursor: 'pointer',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        display: 'block',
                        width: 'calc(100% - 20px)'
                    }}
                    onClick={e => {
                        if (doc.url) {
                            this.props.openDocumentByUrl(doc.url)
                        } else {
                            this.props.openDocument(doc.id)
                        }
                    }}
                >
                    {doc.fileName}
                </span>
                <span className="glyphicon glyphicon-remove"
                    data-toggle="tooltip"
                    title={I18n.t('delete')}
                    style={{cursor: 'pointer'}}
                    onClick={e => {this.props.onDocDelete(doc.id,doc.fileName)}}
                />
            </Flex>
        });

        if (this.props.fileNames.length > 0) {
            for (var i = 0; i < this.props.fileNames.length; i++) {
                var docName = this.props.fileNames[i];
                docsList.push(
                    <Flex alignItems="center" key={'doc' + i}
                            eventKey={'doc' + i}
                            style={{cursor: 'default', padding: "4px"}}
                            className="docs-dropdown-test-detail-menu-item"
                    >
                        <span data-toggle="tooltip"
                            title={docName}
                            onClick={this.handleUploadedDocumentsMenuClose}
                            style={{
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                display: 'block',
                                width: 'calc(100% - 20px)'
                            }}
                        >
                            {docName}
                        </span>
                        <span className="glyphicon glyphicon-remove"
                            data-toggle="tooltip"
                            title={I18n.t("Delete")}
                            style={{cursor: 'pointer'}}
                            onClick={e => {this.props.onDocDelete(undefined,docName)}}
                        />
                    </Flex>
                )
            }
        }
        const dropDownStyles = {
            container: (base, state) => ({
                ...base,
                height: '34px',
                paddingBottom: '6px '
            }),
            control: (base, state) => {
                let borderColor = state.isFocused ? '#66afe9' : '#ccc';
                return {
                ...base,
                height: '34px',
                minHeight: '34px',
                padding: '0px 3px',
                backgroundColor: '#fff',
                borderColor: borderColor
            }},
            indicatorSeparator: (base, state) => ({
                ...base,
                display: 'none'
            }),
            option: (base, state) => {
                let bc = '#fff';
                if (state.isFocused || state.isSelected) {
                    bc = '#eeeeee'
                }
                return {
                    ...base,
                    color: '#333',
                    height: '24px',
                    minHeight: '24px',
                    backgroundColor: bc,
                    padding: '3px 10px'
                }
            }
        };

        const testStyle = {
            ...dropDownStyles,
            menu: (base, state) => ({
                ...base,
                width: '130%'
            })
        };

        const syncWithAmbry = this.props.test.ambryId > 0 && this.props.test.orderid > 0;
        const { fields, renderAdditionalFieldBefore = () => {} } = this.props;
        const isFieldAvailable = (fieldComponent, fieldName) => {
            if (!fields || fields?.includes(fieldName)) {
                return fieldComponent;
            }

            return null;
        };

        const UPLOADED_DOC_DROPDOWN_PORTAL_ID = "uploadedDocDropdown";

        return (
            <Modal
                style={{top: '12%'}} 
                bsSize="large" 
                bsClass="bootstrap modal" 
                show={this.props.show} 
                animation={false}
                className="TestDetails-dialog"
                backdrop="static"
                onHide={this.props.onHide} 
            >
                <ModalHeader closeButton onHide={this.props.onHide}>
                    <ModalTitle id="test-details-header" style={{color: '#008DCE', fontWeight: 'normal'}}>{this.props.title ?? I18n.t('testDetails')}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div>
                        {this.topLabel}
                        <a id="anc-test-details-err" href="#" style={this.props.ambryError ? {} : {display: 'none'}} onClick={this.props.onSeeDetails}>
                            {I18n.t('seeDetails')}
                        </a>
                    </div>
                    <div className="row" style={{marginTop: '20px'}}>
                        <div className="col-sm-4">
                            {isFieldAvailable(<div className="row" style={{marginBottom: '5px'}}>
                                <div id="lbl-test-details-lab" className="col-sm-4" style={{fontWeight: 'bold', lineHeight: '30px'}}>
                                    {I18n.t('lab')}
                                </div>
                                <div className="col-sm-8 test-details-dd">
                                    <Dropdown
                                        searchable
                                        withEmptyOption
                                        id="lab"
                                        styles={dropDownStyles}
                                        selectedValue={this.props.test.lab ? this.props.test.lab : ''}
                                        options={uniqueLabs}
                                        onValueChanged={(e) => {this.props.onLabSelected(e)}}
                                        dropupAuto={true}
                                        isDropup={false}
                                        disabled={this.props.test.id}>
                                    </Dropdown>
                                    {this.props.errors.lab && (
                                        <HelpBlock className="TestDetails-dialog__error-message">
                                            {this.props.errors.lab}
                                        </HelpBlock>
                                    )}
                                </div>
                            </div>, 'lab')}
                            {isFieldAvailable(this.props.test.lab === OTHER_LAB_OPTION_NAME && (
                                <div className="row" style={{marginBottom: '5px'}}>
                                    <div {...getTestAttributes('TestResults', 'otherLab', 'label')} className="col-sm-4" style={{fontWeight: 'bold', lineHeight: '30px'}}>
                                        {I18n.t('otherLab')}
                                    </div>
                                    <div className="col-sm-8 test-details-dd">
                                        <FormControl 
                                            {...getTestAttributes('TestResults', 'otherLab', 'input')}
                                            errorMessage={this.state.errorMessages.otherLab || this.props.errors.otherLab}
                                            value={this.props.test.otherLab ?? ""}
                                            className="TestDetails-dialog__other-text-field"
                                            placeholder={I18n.t('otherLab')}
                                            disabled={this.props.test.id}
                                            onChange={this.handleOtherLabChange}
                                        />
                                    </div>
                                </div>
                            ), 'otherLab')}
                            {renderAdditionalFieldBefore('test')}
                            {isFieldAvailable(<div className="row" style={{marginBottom: '5px'}}>
                                <div id="lbl-test-details-test" className="col-sm-4" style={{fontWeight: 'bold', lineHeight: '30px'}}>
                                    {I18n.t('test')}
                                </div>
                                <div className="col-sm-8 test-details-dd">
                                    <Dropdown
                                        searchable
                                        withEmptyOption
                                        id="testOrdered"
                                        styles={testStyle}
                                        selectedValue={this.props.test.testOrdered ? this.props.test.testOrdered : ''}
                                        options={testsOrdered}
                                        onValueChanged={(e) => {this.props.onTestOrderedSelected(e)}}
                                        dropupAuto={true}
                                        isDropup={false}
                                        disabled={!testsEnabled || this.props.test.id}>
                                    </Dropdown>
                                </div>
                            </div>, 'test')}
                            {isFieldAvailable(this.props.test.testOrdered === OTHER_TEST_OPTION_NAME && (
                                <div className="row" style={{marginBottom: '5px'}}>
                                    <div {...getTestAttributes('TestResults', 'otherTestOrdered', 'label')} className="col-sm-4" style={{fontWeight: 'bold', lineHeight: '30px'}}>
                                        {I18n.t('otherTest')}
                                    </div>
                                    <div className="col-sm-8 test-details-dd">
                                        <FormControl 
                                            {...getTestAttributes('TestResults', 'otherTestOrdered', 'input')}
                                            errorMessage={this.state.errorMessages.otherTest || this.props.errors.otherTest}
                                            value={this.props.test.otherTestOrdered ?? ""}
                                            className="TestDetails-dialog__other-text-field"
                                            placeholder={I18n.t('otherTest')}
                                            onChange={this.handleOtherTestChange}
                                            disabled={this.props.test.id}
                                        />
                                    </div>
                                </div>
                            ), 'otherTest')}

                            {isFieldAvailable(<div className="row" style={{marginBottom: '5px'}}>
                                <div id="lbl-test-details-sub-date" className="col-sm-4" style={{fontWeight: 'bold', lineHeight: '30px'}}>
                                    {I18n.t('submittedDate')}
                                </div>
                                <div className="col-sm-8">
                                    <div className={this.props.errors.submittedDate ? "form-group has-error" : "form-group"} style={{fontSize: '13px'}}>
                                        <DatePicker
                                            id="submittedDate"
                                            ref={(node) => { this.picker1 = node; }}
                                            className="form-control"
                                            selected={this.props.test.submittedDate ? moment(this.props.test.submittedDate).toDate() : null}
                                            utcOffset='0'
                                            onChange={(e) => {this.handleDateChange("submittedDate", e)}}
                                            onBlur={(e) => {this.handleDateBlur(e.target)}}
                                            disabledKeyboardNavigation
                                            onClickOutside={this.onOutsideClick}
                                            readOnly={syncWithAmbry}
                                        />
                                        {this.props.errors.submittedDate && (
                                            <ErrorText withTopGap id="tooltip-right" text={`${I18n.t('Requires')} '${localDateFormat}' ${I18n.t('format')}`} />
                                        )}
                                    </div>
                                </div>
                            </div>, 'submittedDate')}

                            {isFieldAvailable(<div className="row" style={{marginBottom: '5px'}}>
                                <div id="lbl-test-details-rep-date" className="col-sm-4" style={{fontWeight: 'bold', lineHeight: '30px'}}>
                                    {I18n.t('reportedDate')}
                                </div>
                                <div className="col-sm-8">
                                    <div className={this.props.errors.reportedDate ? "form-group has-error" : "form-group"} style={{fontSize: '13px'}}>
                                        <DatePicker
                                            id="reportedDate"
                                            ref={(node) => { this.picker2 = node; }}
                                            className="form-control"
                                            selected={this.props.test.reportedDate ? moment(this.props.test.reportedDate).toDate() : null}
                                            utcOffset='0'
                                            onChange={(e) => {this.handleDateChange("reportedDate", e)}}
                                            onBlur={(e) => {this.handleDateBlur(e.target)}}
                                            disabledKeyboardNavigation
                                            onClickOutside={this.onOutsideClick}
                                            readOnly={syncWithAmbry}
                                        />
                                        {this.props.errors.reportedDate && (
                                            <ErrorText withTopGap id="tooltip-right" text={`${I18n.t('Requires')} '${localDateFormat}' ${I18n.t('format')}`} />
                                        )}
                                    </div>
                                </div>
                            </div>, 'reportedDate')}

                            {isFieldAvailable(<div className="row" style={{marginBottom: '5px'}}>
                                <div id="lbl-test-details-rec-date" className="col-sm-4" style={{fontWeight: 'bold', lineHeight: '30px'}}>
                                    {I18n.t('reclassDate')}
                                </div>
                                <div className="col-sm-8">
                                    <div className={this.props.errors.reclassDate ? "form-group has-error" : "form-group"} style={{fontSize: '13px'}}>
                                        <DatePicker
                                            id="reclassDate"
                                            ref={(node) => { this.picker3 = node; }}
                                            className="form-control"
                                            selected={this.props.test.reclassDate ? moment(this.props.test.reclassDate).toDate() : null}
                                            utcOffset='0'
                                            onChange={(e) => {this.handleDateChange("reclassDate", e)}}
                                            onBlur={(e) => {this.handleDateBlur(e.target)}}
                                            disabledKeyboardNavigation
                                            onClickOutside={this.onOutsideClick}
                                            readOnly={syncWithAmbry}
                                        />
                                        {this.props.errors.reclassDate && (
                                            <ErrorText withTopGap id="tooltip-right" text={`${I18n.t('Requires')} '${localDateFormat}' ${I18n.t('format')}`} />
                                        )}
                                    </div>
                                </div>
                            </div>, 'reclassDate')}

                            {isFieldAvailable(<div className="row" style={{marginBottom: '5px'}}>
                                <div id="lbl-test-details-status" className="col-sm-4" style={{fontWeight: 'bold', lineHeight: '30px'}}>
                                    {I18n.t('status')}
                                </div>
                                <div className="col-sm-8 test-details-dd">
                                    <Dropdown
                                        id="testStatus"
                                        styles={dropDownStyles}
                                        selectedValue={this.props.test.testStatus ? this.props.test.testStatus : ''}
                                        searchable={false}
                                        options={statuses}
                                        withEmptyOption
                                        onValueChanged={(e) => {this.props.onTestStatusSelected(e)}}
                                        dropupAuto={true}
                                        isDropup={false}
                                        disabled={syncWithAmbry}>
                                    </Dropdown>
                                </div>
                            </div>, 'status')}

                            {isFieldAvailable(<div className="row" style={{marginBottom: '5px'}}>
                                <div id="lbl-test-details-result" className="col-sm-4" style={{fontWeight: 'bold', lineHeight: '30px'}}>
                                    {I18n.t('result')}
                                </div>
                                <div className="col-sm-8">
                                    <input type="text"
                                           id="result"
                                           className="form-control progeny-tests-disabled"
                                           style={{textOverflow: 'ellipsis', fontSize: '13px'}}
                                           data-toggle="tooltip"
                                           data-placement="top"
                                           title={results}
                                           disabled="disabled"
                                           value={results}
                                    ></input>
                                </div>
                            </div>, 'result')}

                            {isFieldAvailable(<div className="row" style={{marginBottom: '5px'}}>
                                <div id="lbl-test-details-doc" className="col-sm-4" style={{fontWeight: 'bold', lineHeight: '30px'}}>
                                    {I18n.t('document')}
                                </div>
                                <div className="col-sm-8">
                                    <div className="input-group" style={{width: '100%'}}>
                                        <ClickAwayListener onClickAway={this.handleUploadedDocumentsMenuClose}>
                                            <div className="btn-group docs-dropdown-test-detail dropdown" style={{width: '100%'}} id={UPLOADED_DOC_DROPDOWN_PORTAL_ID}>
                                                <Dropdown
                                                    menuIsOpen={this.state.uploadedDocumentsMenuOpened}
                                                    isSearchable={false}
                                                    selectedValue={docsButton}
                                                    onValueChanged={(e) => {this.props.onTestOrderedSelected(e)}}
                                                    menuListComponent={this.getMenuListComponent(docsList)}
                                                    controlComponent={this.getControlComponent(docsButton)}
                                                    id={'dropdown-basic-'}
                                                    className="docs-dropdown-test-detail-button"
                                                    menuPortalTarget={document.getElementById(UPLOADED_DOC_DROPDOWN_PORTAL_ID)}
                                                />
                                            </div>
                                        </ClickAwayListener>
                                        <div className="input-group-addon btn btn-file" style={{backgroundColor: 'transparent', width: '0.5%'}}>
                                            <i id="fa-test-details-upload" className="fa fa-upload" aria-hidden="true"></i>
                                            <input id="file-test-details-upload" type="file" onChange={this.onUpload} multiple></input>
                                        </div>
                                    </div>
                                </div>
                            </div>, 'document')}

                            {isFieldAvailable(<div className="row" style={{marginBottom: '5px'}}>
                                <div id="lbl-test-details-notes" className="col-sm-4" style={{fontWeight: 'bold', lineHeight: '30px'}}>
                                    {I18n.t('notes')}
                                </div>
                                <div className="col-sm-8">
                                    <textarea
                                        id="notes"
                                        className="form-control"
                                        value={this.props.test.notes ? this.props.test.notes : ''}
                                        style={{height: '130px', resize: 'none', fontSize: '13px'}}
                                        onChange={(e) => {this.handleOnChange(e.target)}}
                                    ></textarea>
                                </div>
                            </div>, 'notes')}
                        </div>
                        <div style={{paddingLeft: '0px'}} className="col-sm-8">
                            <GenesTableController />
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter>
                    <Button id="btn-test-details-cancel" key="no" onClick={this.props.onHide}>{I18n.t('Cancel')}</Button>
                    {this.props.withSaveAsBtn && (
                        <Button 
                            bsStyle="primary"
                            disabled={this.hasErrors() || !this.hasSomeDataEntered || this.props.saving || (this.props.hasErrors && this.props.hasErrors())}
                            {...getTestAttributes('TestResults', 'save-as', 'button')}
                            onClick={this.props.onSaveAs}
                        >
                            {I18n.t('Save As')}
                        </Button>
                    )}
                    <Button id="btn-test-details-save" key="ok"
                                   type="submit"
                                   onClick={this.props.onSave}
                                   disabled={this.hasErrors() || !this.hasSomeDataEntered || this.props.saving || (this.props.hasErrors && this.props.hasErrors())}
                                   bsStyle="primary"
                    >
                        {I18n.t('save')}
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }
}

TestDetailsWnd.propTypes = {
    show: PropTypes.bool.isRequired,
    saving: PropTypes.bool.isRequired,
    test: PropTypes.object.isRequired,
    labs: PropTypes.array.isRequired,
    testsOrdered: PropTypes.array.isRequired,
    genes: PropTypes.array.isRequired,
    errors: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
    onAddRow: PropTypes.func.isRequired,
    onDeleteRow: PropTypes.func.isRequired,
    saveFieldValue: PropTypes.func.isRequired,
    onLabSelected: PropTypes.func.isRequired,
    onTestOrderedSelected: PropTypes.func.isRequired,
    onTestStatusSelected: PropTypes.func.isRequired,
    onValidationResult: PropTypes.func.isRequired,
    onDocsUploaded: PropTypes.func.isRequired,
    onSeeDetails: PropTypes.func.isRequired,
    loadBlacklistFileExtensions: PropTypes.func.isRequired,
    ambryError: PropTypes.bool.isRequired,
    multipleReportsShown: PropTypes.bool.isRequired,
    showMultipleReportsMessage: PropTypes.func.isRequired,
    blacklistFileExtensions: PropTypes.arrayOf(PropTypes.string).isRequired,
    showBlacklistUploadedFilesMessage: PropTypes.func.isRequired,
};